import { useInitData } from '../../../hooks'
import { getRequestProfilePathname } from '../../../utils/link'
import { BirdviewCard } from '../BirdviewCard'
import { BirdviewServiceRequestRow } from '../BirdviewServiceRequestRow'
import { useBirdviewListTarget } from '../DashboardBirdview.hooks'
import { getBirdviewRowRequestActions } from '../DashboardBirdview.utils.rows'

function BirdviewServiceRequestsWidget({
  Meta,
  actionKey,
  dragHandleProps,
  getMetaProps,
  requestActions,
  section,
  showAllTarget,
  title,
  onNavigate,
}) {
  const { availableSections } = useInitData()
  const { getListTarget } = useBirdviewListTarget()

  const rowRequestActions = getBirdviewRowRequestActions({
    requestActions,
    onReload: section.reload,
  })

  function handleShowAll() {
    onNavigate(getListTarget(showAllTarget))
  }

  function handleOpen(item) {
    onNavigate(getRequestProfilePathname({ availableSections, id: item.id }))
  }

  return (
    <BirdviewCard
      count={section.total}
      dragHandleProps={dragHandleProps}
      hasMore={section.hasMore}
      isRefreshing={section.isRefreshing}
      state={section.state}
      title={title}
      onRetry={section.reload}
      onShowAll={handleShowAll}
    >
      {section.items.map(item => (
        <BirdviewServiceRequestRow
          Meta={Meta}
          actionKey={actionKey}
          extra={section.extra}
          getMetaProps={getMetaProps}
          item={item}
          key={item.id}
          requestActions={rowRequestActions}
          onOpen={handleOpen}
        />
      ))}
    </BirdviewCard>
  )
}

export default BirdviewServiceRequestsWidget
